import { baseUrl } from 'config/config';
import { useState, useEffect } from 'react';
import { postApiCall } from './apiHelper';
import {  DashboarUserCallConstants } from '../all_Interfaces';
import { useAppSelector } from '../redux/hooks';

export const useLeaseLoader = () => {

  const userDetails = useAppSelector((state) => state.userContextDetails?.data)
  const [isInProgress, setIsInProgress] = useState(false);

  const constants: DashboarUserCallConstants = {
    GET_IN_PROGRESS_LEASES_URL: `${baseUrl}Leases/GetInProgressLeases`,
    GET_IN_PROGRESS_LEASE_FOR_AM_ANALYST_URL: `${baseUrl}Leases/GetInProgressLeaseForAM`,
    GET_LEASE_BY_STATUS: `${baseUrl}Leases/GetLeaseByBasedOnStatus`,
    GET_ACTIVE_LEASES_URL: `${baseUrl}Leases/GetActiveLeases`,
    GET_ACTIVE_LEASE_FOR_AM_ANALYST: `${baseUrl}Leases/GetActiveLeaseForAM`
  };

  const lazyLoadFilters = async (url: string, event: any) => {
    const response = await postApiCall<any, any>(url, event);
    return response.result;
  };

  const loadLeasesByView = async (viewIndex: number, event: any) => {
    const userRole = userDetails[0]?.role.toLowerCase();

    switch (viewIndex) {
      case 0:
        if (['accenture', 'accounting', 'admin', 'analyst'].includes(userRole)) {
          setIsInProgress(true);
          return await lazyLoadFilters(constants.GET_IN_PROGRESS_LEASES_URL, event);
        }
        else if (userRole === 'asset manager') {
          setIsInProgress(true);
          return await lazyLoadFilters(constants.GET_IN_PROGRESS_LEASE_FOR_AM_ANALYST_URL, event);
        }
        else if (['property manager', 'assistant property manager', 'property mgmt accountant'].includes(userRole)) {
          setIsInProgress(true);
          return await lazyLoadFilters(`${constants.GET_LEASE_BY_STATUS}/inprogress`, event);
        }
        break;
      case 1:
        if (['accenture', 'accounting', 'admin', 'analyst'].includes(userRole)) {
          setIsInProgress(false);
          return await lazyLoadFilters(constants.GET_ACTIVE_LEASES_URL, event);
        }
        else if (userRole === 'asset manager') {
          setIsInProgress(false);
          return await lazyLoadFilters(constants.GET_ACTIVE_LEASE_FOR_AM_ANALYST, event);
        }
        else if (['property manager', 'assistant property manager', 'property mgmt accountant'].includes(userRole)) {
          setIsInProgress(false);
          return await lazyLoadFilters(`${constants.GET_LEASE_BY_STATUS}/active`, event);
        }
        break;
    }
  };

  return { loadLeasesByView, isInProgress };
};
